import React from 'react';
import PropTypes from 'prop-types';

import WebGalleryProOnboardingInterstitial from './WebGalleryProOnboardingInterstitial';
import withModal from '../../../../components/global/modal/withModal';

export const WEB_GALLERY_PRO_ONBOARDING_MODAL =
  'modals/WEB_GALLERY_PRO_ONBOARDING';

const propTypes = {
  actionProps: PropTypes.shape({
    albumFolderId: PropTypes.string.isRequired,
  }),
  onCloseAction: PropTypes.func,
};

const WebGalleryProOnboardingInterstitialModalWrapper = ({
  actionProps: { albumFolderId } = {},
  ...props
}) => {
  return (
    <WebGalleryProOnboardingInterstitial
      albumFolderId={albumFolderId}
      {...props}
    />
  );
};

WebGalleryProOnboardingInterstitialModalWrapper.propTypes = propTypes;

export default withModal(WebGalleryProOnboardingInterstitialModalWrapper, {
  name: WEB_GALLERY_PRO_ONBOARDING_MODAL,
  size: 'xl',
  type: 'full',
  hideHeader: true,
});
